module.exports = __webpack_public_path__ + "static/img/fenlei.01d546e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fenlei.jpg
// module id = 3LHs
// module chunks = 52